namespace TotalContest {
    import Component = TotalCore.Common.Component;
    import ISCEService = angular.ISCEService;
    import IWindowService = angular.IWindowService;
    import IAngularEvent = angular.IAngularEvent;

    @Component('components.totalcontest', {
        templateUrl: 'blocks-editor-template',
        bindings: {
            model: '=ngModel',
        }
    })
    class BlocksEditorComponent {
        isMenuOpen = false;
        blocks = [];
        suggestions = {
            basics: [
                'id',
                'contest',
                'date',
                'title',
                'time',
                'views',
                'viewsWithLabel',
                'votes',
                'votesWithLabel',
                'rate',
                'rateWithLabel',
                'percentage',
                'percentageWithLabel',
            ],
            user: [
                'user.display_name',
                'user.first_name',
                'user.last_name',
                'user.description',
            ],
            images: [],
            fields: [],
            contents: [],
            other: [],
        };
        labels = {
            'id': 'ID',
            'contest': 'Contest Title',
            'date': 'Date',
            'title': 'Submission Title',
            'time': 'Time',
            'views': 'Views',
            'viewsWithLabel': 'Views (with label)',
            'votes': 'Votes',
            'votesWithLabel': 'Votes (with label)',
            'rate': 'Rate',
            'rateWithLabel': 'Rate (with label)',
            'percentage': 'Percentage',
            'percentageWithLabel': 'Percentage (with label)',
            'user.display_name': 'Display name',
            'user.first_name': 'First name',
            'user.last_name': 'Last name',
            'user.description': 'Description',
        };

        //@PRO
        // @ts-ignore
        constructor(private $scope, private $sce: ISCEService, private $window: IWindowService, private SettingsService: SettingsService, private UniqueIdService: UniqueIdService, private I18nService: I18nService) {

        }

        $onInit() {
            // @ts-ignore
            this.blocks = this.$scope.blocks = this.model || [];
            this.$scope.$root.$watch('settings.contest.form.fields', (fields) => {
                this.suggestions.images = [];
                this.suggestions.fields = [];
                this.suggestions.contents = [];
                this.suggestions.other = [];

                // @ts-ignore
                angular.forEach(fields, (field) => {
                    if (['video', 'audio', 'embed'].indexOf(field.type) != -1) {
                        this.labels[`contents.${field.name}.content`] = field.label || field.name || field.type;
                        this.suggestions.contents.push(`contents.${field.name}.content`);

                        this.labels[`contents.${field.name}.preview`] = `${field.label || field.name || field.type} (Preview)`;
                        this.suggestions.contents.push(`contents.${field.name}.preview`);

                        this.labels[`contents.${field.name}.thumbnail.url`] = `${field.label || field.name || field.type} (Thumbnail)`;
                        this.suggestions.images.push(`contents.${field.name}.thumbnail.url`);

                    } else if (field.type == 'richtext') {
                        this.labels[`contents.${field.name}.content`] = field.label || field.name || field.type;
                        this.suggestions.contents.push(`contents.${field.name}.content`);
                    } else if (field.type == 'image') {
                        this.labels[`contents.${field.name}.attachment.url`] = `${field.label || field.name || field.type}`;
                        this.suggestions.images.push(`contents.${field.name}.attachment.url`);

                        this.labels[`contents.${field.name}.thumbnail.url`] = `${field.label || field.name || field.type} (Thumbnail)`;
                        this.suggestions.images.push(`contents.${field.name}.thumbnail.url`);

                        this.labels[`contents.${field.name}.content`] = field.label || field.name || field.type;
                        this.suggestions.contents.push(`contents.${field.name}.content`);
                    } else if (field.type == 'category') {
                        this.labels[`category.name`] = field.label || field.name || field.type;
                        this.suggestions.other.push(`category.name`);
                    } else if (field.type == 'file') {
                        this.labels[`contents.${field.name}.content`] = field.label || field.name || field.type;
                        this.suggestions.contents.push(`contents.${field.name}.content`);

                        this.labels[`contents.${field.name}.attachment.url`] = (field.label || field.name || field.type) + ' (Attachment URL)';
                        this.suggestions.other.push(`contents.${field.name}.attachment.url`);
                    } else {
                        this.labels[`fields.${field.name}`] = field.label || field.name || field.type;
                        this.suggestions.fields.push(`fields.${field.name}`);
                    }


                });
            }, true);
        }

        normalize(content) {
            return this.$sce.trustAsHtml(content.replace(/\n\r|\n|\r/g, '<br>') || '&nbsp;');
        }

        add(type: string) {
            this.isMenuOpen = false;
            this.blocks.push({
                uid: this.UniqueIdService.generate(),
                type: type,
                expressions: []
            });
        }

        addExpression(block, type) {
            block.expressions.push({
                uid: this.UniqueIdService.generate(),
                type: type,
                source: ''
            });
        }

        removeExpression(block, index, ask: boolean = false, $event: IAngularEvent) {
            if (ask && block.expressions[index].source && !confirm(this.I18nService.__(['Are you sure?']))) {
                $event.stopPropagation();
                return false;
            }

            block.expressions.splice(index, 1);
            return false;
        }

        remove(index, ask: boolean = false, $event: IAngularEvent) {
            if (ask && !confirm(this.I18nService.__(['Are you sure?']))) {
                $event.stopPropagation();
                return false;
            }


            this.blocks.splice(index, 1);
            return false;
        }

        //@END-PRO
    }
}
